module.exports = __webpack_public_path__ + "static/media/sign-ISO.d791acc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/sign-ISO.svg
// module id = 81
// module chunks = 0